<template>
  <fieldset class="options-dropdown-facet">
    <legend>
      <button
        class="tag-selection-toggle-button"
        type="button"
        id="toggle-btn-1"
        aria-controls="target-selection-box-1"
        aria-expanded="true"
        disabled
      >
        <span>{{ title }}</span>
        <i class="icon-plus" aria-hidden="true"></i>
      </button>
    </legend>

    <div class="search-filter dmd-search-filter">
      <input type="text" :placeholder="placeholder" v-model="search" />
    </div>

    <div
      class="options-dropdown-facet__checkboxes"
      id="target-selection-box-1"
      aria-hidden="false"
      aria-labelledby="toggle-btn-1"
    >
      <div
        class="checkbox dmd-checkbox"
        v-for="item in itemsDisplayFiltered"
        :key="item._id"
      >
        <label :for="getId(item)">
          <input
            class="checkbox__input"
            type="checkbox"
            :value="item._id"
            :id="getId(item)"
            @change="changed"
          />
          <!-- <span class="checkmark" aria-hidden="true"></span> -->
          {{ item.name }} ({{ item.facetCount }})
        </label>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "SearchFilterList",
  data() {
    return {
      search: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
      required: true,
    },
    itemsDisplay: {
      type: Array,
      default: () => [],
      required: true,
    },
    checkedItems: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    changed(event) {
      if (event.target.value) {
        var item = this.itemsDisplay.find((x) => x._id === event.target.value);
        this.$emit("add", item);
      }
    },
    resetSearch() {
      this.search = "";
    },
    getId(item) {
      return (
        item._id +
        "-" +
        item.name
          .replace(/[^a-zA-Z ]/g, "")
          .replace(" ", "-")
          .replace(" ", "-")
          .toLowerCase()
      );
    },
  },
  computed: {
    itemsDisplayFiltered() {
      return this.itemsDisplay.filter((item) => {
        var checkedItemsId = this.checkedItems.map(function(obj) {
          return obj._id;
        });

        // remove checkedItems
        if (checkedItemsId.includes(item._id)) {
          return false;
        }

        // search
        if (item.facetCount > 0 && item.name.match(/[[\]]/) === null && item.name !== "" && isNaN(parseInt(item.name)) && !item.name.startsWith('(')) {
          return item.name.toLowerCase().includes(this.search.toLowerCase());
        } else {
          return false;
        }
      }).slice(0, 1000).sort((a, b) => {
        // set limit of entries and sort list
        const itemNameA = a.name;
        const itemNameB = b.name;
        return itemNameA.localeCompare(itemNameB);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* scrollbar */
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #000;
  border-left: 2px solid transparent;
  border-right: 2px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb {
  background: #000;
  min-height: 50px;
}

.search-and-filter .options-dropdown-facet__checkboxes {
  display: inline-block;
  width: 100%;
  height: 300px;
  padding-right: 30px;
  overflow: auto;
  border-right: 0px;
  overflow-y: scroll;
}

/* search */
.dmd-search-filter {
  color: #000;
  background: #d9d9d9;
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 5px;

  input {
    width: -webkit-fill-available;
  }

  input::placeholder {
    color: #000;
    font-size: 20px;
  }
}

.dmd-checkbox {
  label {
    display: flex;
    padding-left: 0;
  }
}
</style>
